/**
 * App Logo — single source of truth for theme-aware logo selection.
 *
 * Light mode → /loginlogo.svg
 * Dark mode  → /darkmode.svg
 *
 * Used by all app components AND favicon sync.
 */

const DARK_MODE_KEY = "hps-dark-mode"

export function getAppLogo(): string {
  if (typeof window === "undefined") return "/loginlogo.svg"

  const stored = localStorage.getItem(DARK_MODE_KEY)
  const isDark = stored !== null
    ? stored === "true"
    : window.matchMedia("(prefers-color-scheme: dark)").matches

  return isDark ? "/darkmode.svg" : "/loginlogo.svg"
}
